import type { ProductListItemModel } from 'autogen/swagger/all';
import { createProductItemTrackingContext } from 'components/shared/productItem/shared/helpers';
import { firstCharacterToLower } from 'modules/helpers/strings';
import type { IHorizontalProductItem } from './types';

const modelMapper = (model: ProductListItemModel, recommendationPlacement?: string): IHorizontalProductItem => {
    const {
        id,
        externalProductId,
        linkAction,
        standardName,
        priceInfo,
        listName,
        primaryImage,
        action,
        variants,
        splashes,
        isSubscribable,
        isSubscriptionContext,
        addToBasketType,
        requireLoginForCheckout,
        fromPowerstep,
        showPowerstepOnAddToBasket,
        bundleInfo,
        dataLayerDto,
        uaTrackingCategory,
        uaTrackingLabel,
        trackModel,
        favoriteStatus,
        isSponsored,
        snippet,
        averageRating,
        reviewCount
    } = model;

    const { listName: dataLayerListName } = dataLayerDto;

    const trackingContext = createProductItemTrackingContext(
        firstCharacterToLower(uaTrackingCategory),
        uaTrackingLabel,
        trackModel,
        bundleInfo,
        recommendationPlacement
    );

    /* Mapped Product model */
    const productModel: IHorizontalProductItem['productModel'] = {
        id,
        externalProductId,
        linkAction,
        standardName,
        listName,
        image: primaryImage,
        price: priceInfo,
        splashes,
        trackModel,
        dataLayerDto,
        favoriteStatus,
        variants,
        isSponsored,
        snippet,
        averageRating,
        reviewCount
    };

    /* Mapped Action model */
    const actionModel: IHorizontalProductItem['actionModel'] = {
        productId: id,
        externalProductId,
        productNavigationLink: linkAction,
        action,
        isSubscriptionContext,
        isSubscribable,
        bundleInfo,
        fromPowerstep,
        showPowerstepOnAddToBasket,
        addToBasketType,
        requireLoginForCheckout,
        variants,
        listName: dataLayerListName,
        trackingContext
    };

    /* Mapped Final model */
    const productItemModel: IHorizontalProductItem = {
        productModel,
        actionModel
    };

    return productItemModel;
};

export default modelMapper;
